/*global ClipboardJS */

var awardCodeGenerator = {
    init: function() {
        var options = {
                disable_search: true,
                inherit_select_classes: true,
                width: '100%'
            },
            generateLink = $('#generateLink');

        $('#pick-color, #pick-size').chosen(options).on('change', function() {
            awardCodeGenerator.generateUrl();
        });

        var copyLink = new ClipboardJS('.btn-copy');

        copyLink.on('success', function(event) {
            event.clearSelection();
            event.trigger.textContent = _d.t.copied;
            window.setTimeout(function() {
                event.trigger.textContent = _d.t.copyCode;
            }, 2000);
        });

        generateLink.on('click', function(e) {
            e.preventDefault();

            awardCodeGenerator.generateUrl();
            $('.clipboard').slideDown();
            $('#generateLink').removeClass('loading');
        });
    },
    generatePreview: function(url) {
        $('#awardImage').attr('src', url);
    },
    generateUrl: function() {
        var color = $('#pick-color').chosen().val(),
            size = $('#pick-size').chosen().val(),
            imgUrl = _d.url.bh + '/assets/badge/discovercars-' + (color.length > 0 ? color : '') + (size.length > 0 ? '-' + size + '.png' : ''),
            code = '<a href="' + _d.url.bh + '"><img alt="DiscoverCars.com Excellent Car Rental Service" src="' + imgUrl + '"></a>'.toString();

        awardCodeGenerator.generatePreview(imgUrl);
        $('#copyCode').text(unescape(code));
    }
};
